import React, { Fragment, useState, useEffect } from "react";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";

// Material-UI Icon
import SearchIcon from "@material-ui/icons/Search";

// Custom Style
import { grayColor } from "../../styles/jss/cmsMainStyle";

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    padding: theme.spacing(1, 2),
  },

  list: {
    height: 500,
    // backgroundColor: theme.palette.background.paper,
    overflow: "auto",
  },

  button: {
    margin: theme.spacing(0.5, 0),
  },

  searchBar: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: grayColor[1],
    "&:hover": {
      backgroundColor: grayColor[2],
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },

  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  inputRoot: {
    color: "inherit",
  },

  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "100ch",
    },
  },
}));

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const UserGroupTransferList = (props) => {
  const classes = useStyles();
  const { userList, userGroupValue, setUserGroupValue } = props;

  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState(userList);
  const [right, setRight] = useState([]);
  const [fixLeft, setFixLeft] = useState([]);
  const leftChecked = intersection(checked, userList);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const saveUserGroupValue = (selectedValue) => {
    let tempValue = { ...userGroupValue };

    tempValue.group_members = selectedValue;
    setUserGroupValue(tempValue);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setFixLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));

    saveUserGroupValue(right.concat(leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setFixLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));

    saveUserGroupValue(not(right, rightChecked));
  };

  const getUserGroupValueFromLeft = (a, b) => {
    let keyobj = {};
    for (let i = 0; i < b.length; i++) {
      keyobj[b[i].site_user_seq] = true;
    }

    let rightRec = [];
    for (let i = 0; i < a.length; i++) {
      if (keyobj[a[i].site_user_seq]) {
        rightRec.push(a[i]);
      }
    }

    return rightRec;
  };

  const initModifyValue = () => {
    const rightRec = getUserGroupValueFromLeft(
      left,
      userGroupValue.group_members
    );

    setRight(rightRec);
    setLeft(not(left, rightRec));
    setFixLeft(not(left, rightRec));

    // let internalList = returnRecipientAfterAction(rightRec, userList);
    // fixLeft === null || [] ? setLeft(internalList) : setLeft(fixLeft);
    // right === null ? setRight([]) : setRight(right);
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ "aria-label": "all items selected" }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />

      <Divider />

      <List className={classes.list} dense component="div" role="list">
        {items.map((res) => {
          const labelId = `transfer-list-all-item-${res.user_seq}-label`;

          return (
            <ListItem key={res.user_seq} role="listitem" button>
              <ListItemIcon>
                <Checkbox
                  onClick={handleToggle(res)}
                  checked={checked.indexOf(res) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>

              <ListItemText
                id={labelId}
                primary={res.fullname}
                secondary={res.company.company_name}
              />
            </ListItem>
          );
        })}
      </List>
    </Card>
  );

  const returnRecipientAfterAction = (rightUser, listOfUser) => {
    let rightArr = [];
    if (rightUser && rightUser.length > 0) {
      for (var i = 0; i < rightUser.length; i++) {
        rightArr.push(rightUser[i].site_user_seq);
      }
    }
    let internalList = listOfUser;
    internalList = listOfUser.filter(
      (obj) => !rightArr.includes(obj.site_user_seq)
    );
    return internalList;
  };

  const quickSearch = (event) => {
    const keyWord = event.target.value !== null ? event.target.value : "";
    let filterResult = "";

    let internalList = returnRecipientAfterAction(right, userList);
    filterResult = internalList.filter((item) =>
      item.fullname.toLowerCase().includes(keyWord.toLowerCase())
    );

    setLeft(filterResult);
  };

  useEffect(() => {
    initModifyValue();
  }, []);

  return (
    // console.log("User List | Variable: userList (UserGroupTransferList.js)"),
    // console.log(userList),

    // console.log("Left User List | Variable: left (UserGroupTransferList.js)"),
    // console.log(left),

    // console.log("Right User List | Variable: right (UserGroupTransferList.js)"),
    // console.log(right),

    // console.log("Checked User | Variable: checked (UserGroupTransferList.js)"),
    // console.log(checked),

    // console.log("User Group Value | Variable: userGroupValue (UserGroupTransferList.js)"),
    // console.log(userGroupValue),

    // console.log("---------------------------------------------------------------------------------"),

    <Fragment>
      <div className={classes.searchBar}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>

          <InputBase
            onChange={quickSearch}
            placeholder="Quick Search"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
      </div>

      <Grid
        container
        spacing={2}
        justify="center"
        alignItems="center"
        className={classes.root}
      >
        <Grid item xs={5} md={5}>
          {customList("Choices", left)}
        </Grid>

        <Grid item xs={2} md={2}>
          <Grid container direction="column" alignItems="center">
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>

            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={5} md={5}>
          {customList("Chosen", right)}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default UserGroupTransferList;
